import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div<{ overflowWrap?: boolean }>`
  gap: ${Spacing.HALF};
  flex-wrap: ${ifProp('overflowWrap', 'wrap', 'normal')};
  ${Mixins.Flex.set()};
`;
